export default __webpack_public_path__ + "static/media/logo-bdswiss.0ff3077e.svg";